import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="memberships"
export default class extends Controller {
  static targets = ["searchInput", "searchResults", "newUserFields", "existingUserInfo", "existingUserId", "selectedUserName"]

  changeOwnerType(e) {
    var item = e.currentTarget

    $.ajax({
      type: "GET",
      url: "/memberships/get_potential_membership_owners",
      data: {
        id: item.dataset.membership,
        kind: item.value
      },
      success: function(data) {
        if(data.status == 200) {
          var owners = JSON.parse(data.owners)

          var options = ''
          owners.forEach(function(owner){
            options += '<option value="' + owner[1] + '">' + owner[0] + '</option>'
          })

          document.getElementById('membership_owner_id').innerHTML = options
        } else {
          alert("Error getting owner list.")
        }
      }
    })
  }

  removeRepresentative(e) {
    e.preventDefault()

    var item = e.currentTarget

    var ans = confirm('Are you sure you want to remove this representative?')
    if(ans) {
      $.ajax({
        type: "POST",
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        url: "/memberships/remove_representative",
        data: {
          membership_id: item.dataset.membership,
          user_id: item.dataset.user
        },
        success: function(data) {
          if(data.status == 200) {
            document.getElementById('representative_' + data.id).remove()
          } else {
            alert("Failed to remove representative: " + (data.error || "Unknown error"))
          }
        },                                                                                                                                                                
        error: function(xhr, status, error) {                                                                                                                                 
          console.error("Request failed:", error)                                                                                                                             
          alert("Failed to remove representative: " + error)                                                                                                                  
        } 
      })
    }
  }

  searchUsers(e) {
    const query = e.target.value
    const resultsContainer = this.searchResultsTarget

    if (query.length < 2) {
      resultsContainer.innerHTML = ''
      resultsContainer.classList.add('d-none')
      return
    }

    $.ajax({
      type: "GET",
      url: "/memberships/search_users",
      data: { query: query },
      success: (data) => {
        if (data.status == 200 && data.users.length > 0) {
          let html = '<div class="list-group">'
          data.users.forEach((user) => {
            html += `<a href="#" class="list-group-item list-group-item-action" data-action="click->memberships#selectUser" data-user-id="${user.id}" data-user-name="${user.name}" data-user-email="${user.email}">${user.name} (${user.email})</a>`
          })
          html += '</div>'
          resultsContainer.innerHTML = html
          resultsContainer.classList.remove('d-none')
        } else {
          resultsContainer.innerHTML = '<div class="text-muted p-2">No users found. You can create a new user below.</div>'
          resultsContainer.classList.remove('d-none')
        }
      }
    })
  }

  selectUser(e) {
    e.preventDefault()
    const userId = e.target.dataset.userId
    const userName = e.target.dataset.userName
    const userEmail = e.target.dataset.userEmail

    // Set the hidden field with the user ID
    this.existingUserIdTarget.value = userId

    // Show the selected user info
    this.selectedUserNameTarget.innerHTML = `<strong>${userName}</strong> (${userEmail})`
    this.existingUserInfoTarget.classList.remove('d-none')

    // Hide the new user form fields
    this.newUserFieldsTarget.classList.add('d-none')

    // Clear and hide search results
    this.searchResultsTarget.innerHTML = ''
    this.searchResultsTarget.classList.add('d-none')
    this.searchInputTarget.value = ''
  }

  clearSelectedUser(e) {
    e.preventDefault()

    // Clear the hidden field
    this.existingUserIdTarget.value = ''

    // Hide the selected user info
    this.existingUserInfoTarget.classList.add('d-none')

    // Show the new user form fields
    this.newUserFieldsTarget.classList.remove('d-none')
  }

  connect() {

  }


}
